// revQ side-menu icons — Tabler family (MIT) + three revQ icons drawn to the same grid.
// 24×24 viewBox · stroke 1.6 · round caps/joins · colour = currentColor (inherits the menu item's text colour).
// Usage:  import { IconEncounters } from "./RevqMenuIcons";   <IconEncounters size={18} />
// Do not redraw or swap these for library icons; import as-is.

const Base = ({ size = 18, strokeWidth = 1.6, className, children, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
    {...rest}
  >
    {children}
  </svg>
);

/** Home — custom, drawn to Tabler's grid/stroke to match the build's existing house */
export const IconHome = (props) => (
  <Base {...props}>
    <path d="M3.5 11.5L12 4l8.5 7.5"/>
    <path d="M6 9.5V20h12V9.5"/>
  </Base>
);

/** Patients — Tabler users */
export const IconPatients = (props) => (
  <Base {...props}>
    <path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"/>
    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"/>
  </Base>
);

/** Chart Documents — custom: revQ Lens mark (scan corners + upload arrow), Tabler grid/stroke */
export const IconChartDocuments = (props) => (
  <Base {...props}>
    <path d="M4 8v-2a2 2 0 0 1 2 -2h2"/>
    <path d="M16 4h2a2 2 0 0 1 2 2v2"/>
    <path d="M20 16v2a2 2 0 0 1 -2 2h-2"/>
    <path d="M8 20h-2a2 2 0 0 1 -2 -2v-2"/>
    <path d="M12 15.5v-7"/>
    <path d="M9.5 11l2.5 -2.5l2.5 2.5"/>
  </Base>
);

/** Encounters — Tabler clipboard + custom pulse line */
export const IconEncounters = (props) => (
  <Base {...props}>
    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"/>
    <path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2"/>
    <path d="M8 14h1.6l1.4 -2.8l2 5l1.4 -2.2h1.6"/>
  </Base>
);

/** Claims — Tabler receipt */
export const IconClaims = (props) => (
  <Base {...props}>
    <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"/>
  </Base>
);

/** Payment Posting — Tabler cash-banknote */
export const IconPaymentPosting = (props) => (
  <Base {...props}>
    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>
    <path d="M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -8"/>
    <path d="M18 12h.01"/>
    <path d="M6 12h.01"/>
  </Base>
);

/** Settings — Tabler settings */
export const IconSettings = (props) => (
  <Base {...props}>
    <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065"/>
    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>
  </Base>
);

/** Menu label → icon, in menu order */
export const REVQ_MENU_ICONS = {
  "Home": IconHome,
  "Patients": IconPatients,
  "Chart Documents": IconChartDocuments,
  "Encounters": IconEncounters,
  "Claims": IconClaims,
  "Payment Posting": IconPaymentPosting,
  "Settings": IconSettings,
};
